(function () {
  var pages = document.querySelectorAll('.cr-b2b-page');

  function setupMatcher(page, options) {
    var buttons = page.querySelectorAll(options.buttonSelector);
    var panels = page.querySelectorAll(options.panelSelector);

    if (!buttons.length || !panels.length) {
      return;
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selectedIndex = button.getAttribute(options.buttonAttribute);
        var shouldCollapse = options.allowCollapse && button.getAttribute(options.ariaAttribute) === 'true';

        buttons.forEach(function (currentButton) {
          var isActive = !shouldCollapse && currentButton.getAttribute(options.buttonAttribute) === selectedIndex;
          currentButton.classList.toggle('cr-b2b-page-match-button-active', isActive);
          currentButton.setAttribute(options.ariaAttribute, isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = !shouldCollapse && panel.getAttribute(options.panelAttribute) === selectedIndex;
          panel.hidden = !isActive;
        });
      });
    });
  }

  function setupMaterialRows(page) {
    var toggles = page.querySelectorAll('[data-cr-b2b-material-toggle]');

    if (!toggles.length) {
      return;
    }

    function setOpen(toggle, isOpen) {
      var groupId = toggle.getAttribute('data-cr-b2b-material-toggle');
      var groupRow = page.querySelector('[data-cr-b2b-material-group="' + groupId + '"]');
      var childRows = page.querySelectorAll('[data-cr-b2b-material-child="' + groupId + '"]');

      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (groupRow) {
        groupRow.classList.toggle('cr-b2b-page-material-group-row-open', isOpen);
      }

      childRows.forEach(function (row) {
        row.hidden = !isOpen;
      });
    }

    var initialOpenFound = false;

    toggles.forEach(function (toggle) {
      var isInitiallyOpen = toggle.getAttribute('aria-expanded') === 'true' && !initialOpenFound;

      if (isInitiallyOpen) {
        initialOpenFound = true;
      }

      setOpen(toggle, isInitiallyOpen);

      toggle.addEventListener('click', function () {
        var shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

        toggles.forEach(function (currentToggle) {
          setOpen(currentToggle, currentToggle === toggle && shouldOpen);
        });
      });
    });
  }

  pages.forEach(function (page) {
    var faqItems = page.querySelectorAll('.cr-b2b-page-faq-item');

    if (faqItems.length) {
      faqItems.forEach(function (item, index) {
        item.open = index === 0;

        item.addEventListener('toggle', function () {
          if (!item.open) {
            return;
          }

          faqItems.forEach(function (currentItem) {
            if (currentItem !== item) {
              currentItem.open = false;
            }
          });
        });
      });
    }

    setupMaterialRows(page);

    setupMatcher(page, {
      buttonSelector: '[data-cr-b2b-match-option]',
      panelSelector: '[data-cr-b2b-match-panel]',
      buttonAttribute: 'data-cr-b2b-match-option',
      panelAttribute: 'data-cr-b2b-match-panel',
      ariaAttribute: 'aria-selected'
    });

    setupMatcher(page, {
      buttonSelector: '[data-cr-b2b-match-mobile-option]',
      panelSelector: '[data-cr-b2b-match-mobile-panel]',
      buttonAttribute: 'data-cr-b2b-match-mobile-option',
      panelAttribute: 'data-cr-b2b-match-mobile-panel',
      ariaAttribute: 'aria-expanded',
      allowCollapse: true
    });
  });
})();
